import { useQuery } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import EudrDashboardService from 'src/modules/3rd-party-management/apis/admin/EudrDashboardService';

export const EUDR_TRADE_OPERATIONS_QUERY_KEY = '3rd-party-management-fetch-eudr-trade-operations';

const MONTH_KEYS = {
    1: 'Jan',
    2: 'Feb',
    3: 'Mar',
    4: 'Apr',
    5: 'May',
    6: 'Jun',
    7: 'Jul',
    8: 'Aug',
    9: 'Sep',
    10: 'Oct',
    11: 'Nov',
    12: 'Dec',
};

const SERIES_CONFIG = [
    {
        key: 'totalImport',
        name: 'Total Import',
        color: '#1CBB8C',
    },
    {
        key: 'totalExport',
        name: 'Total Export',
        color: '#5664D2',
    },
];

const useTradeOperations = ({
    t,
}) => {
    const query = useQuery({
        queryKey: [EUDR_TRADE_OPERATIONS_QUERY_KEY],
        queryFn: async () => {
            const service = EudrDashboardService.getInstance();

            return await service.fetchTradeOperations();
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        retry: false,
        onError: (error) => {
            if (process.env.NODE_ENV === 'development') console.error(error);

            toast(t('An error occurred while fetching EUDR trade operations data.'), {
                type: 'error',
            });
        },
    });

    const data = query.data;

    if (!data) {
        return {
            ...query,
            categories: [],
            chartSeries: [],
        };
    }

    const categories = [];
    const importValues = [];
    const exportValues = [];

    (data.series || []).forEach((element) => {
        const monthKey = parseInt((element.month || '').split('-')?.[1] || '0', 10);

        categories.push(MONTH_KEYS[monthKey]);
        importValues.push(Number(element.totalImport) || 0);
        exportValues.push(Number(element.totalExport) || 0);
    });

    const chartSeries = SERIES_CONFIG.map((config) => ({
        name: t(config.name),
        data: config.key === 'totalImport' ? importValues : exportValues,
        color: config.color,
    }));

    return {
        ...query,
        categories,
        chartSeries,
    };
};

export default useTradeOperations;
